var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill font-14 pl-2 pr-2 pt-1 pb-1",class:_vm.currentStatus,staticStyle:{"min-width":"80px","font-weight":"600"}},[_vm._v("\n  "+_vm._s(_vm.statusText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }